import {SettingsService} from '../api/generated/SettingsService.ts';
import {
  PagedDataTableConfig,
  renderEditButton,
  usePagedDataTable,
} from '../hooks/paged-data-table/use-paged-data-table.tsx';
import {ROUTES} from '../routes';
import {BasicPage} from '../components/basic-page.tsx';
import {Group} from '@mantine/core';
import {CopyButton} from '../components/copy-button.tsx';

export const SettingListing = () => {
  const pagedDataTable = usePagedDataTable(
    SettingsService.getAll,
    TableConfig
  );
  return <BasicPage title="Settings">{pagedDataTable}</BasicPage>;
};

const TableConfig = PagedDataTableConfig(SettingsService.getAll, {
  columns: [
    {
      accessor: 'actions',
      title: '',
      render: (item) =>
        renderEditButton({
          item: {...item, id: Number(item.id)},
          descriptor: 'setting',
          route: ROUTES.ADMIN.SETTINGS.DETAIL.path,
        }),
      width: 50,
    },
    {
      accessor: 'key',
      sortable: true,
    },
    {
      accessor: 'value',
      render: (item) => (
        <Group grow={false}>
          {item.value} <CopyButton value={item.value} />
        </Group>
      ),
    },
  ],
  defaultSort: {
    column: 'key',
    direction: 'ASC',
  },
  searchFieldNames: ['key', 'value'],
});